import { PartnerProject } from './../../../app/@shared/models/partner_project.model';
import { Meta } from '@gridscale/gsclient-js';
import { createAction, props } from '@ngrx/store';
import { IRequestOptions } from '../request-options.interface';

const actionPrefix = '[partner_projects]';

export const setListConfig = createAction(actionPrefix + ' Set List Config', props<{ config: IRequestOptions }>());
export const updateListConfig = createAction(actionPrefix + ' Update List Config', props<{ config: IRequestOptions }>());
export const setSearch = createAction(actionPrefix + ' Set Search', props<{ search: string }>());

export const loadPartnerProjects = createAction(actionPrefix + ' Load PartnerProjects');
export const loadPartnerProjectsSuccess = createAction(actionPrefix + ' Load PartnerProjects Success', props<{ data: Record<string, PartnerProject>, meta: Meta, links: { next?: { href: string } } }>());
export const loadPartnerProjectsFailure = createAction(actionPrefix + ' Load PartnerProjects Failure', props<{ error: Error }>());

export const loadPartnerProjectsNext = createAction(
  actionPrefix + ' Load PartnerProjects List Next'
);

export const loadPartnerProjectsNextSuccess = createAction(
  actionPrefix + ' Load PartnerProjects List Next Success',
  props<{ data: Record<string, PartnerProject>, meta: Meta, links: { next?: { href: string } } }>()
);

export const loadPartnerProjectsNextFailure = createAction(
  actionPrefix + ' Load PartnerProjects List Next Failed',
  props<{ error: Error }>()
);

export const loadPartnerProject = createAction(
  actionPrefix + ' Load PartnerProject',
  props<{ uuid: string, contract_uuid: string }>()
);
export const loadPartnerProjectSuccess = createAction(
  actionPrefix + ' Load PartnerProject Success',
  props<{ uuid: string, contract_uuid: string, data: PartnerProject }>()
);
export const loadPartnerProjectFailure = createAction(
  actionPrefix + ' Load PartnerProject Failure',
  props<{ uuid: string, contract_uuid: string, error: Error }>()
);


export const loadPartnerProjectsForLocation = createAction(actionPrefix + ' Load PartnerProjects for location', props<{ locationUuid: string }>());
export const loadPartnerProjectsForLocationSuccess = createAction(actionPrefix + ' Load PartnerProjects for location Success', props<{ locationUuid: string, data: Record<string, PartnerProject>, meta: Meta, links: { next?: { href: string } } }>());
export const loadPartnerProjectsForLocationFailure = createAction(actionPrefix + ' Load PartnerProjects for location Failure', props<{ locationUuid: string, error: Error }>());

export const loadPartnerProjectsForLocationNext = createAction(
  actionPrefix + ' Load PartnerProjects for location List Next',
  props<{ locationUuid: string }>()
);

export const loadPartnerProjectsForLocationNextSuccess = createAction(
  actionPrefix + ' Load PartnerProjects for location List Next Success',
  props<{ locationUuid: string, data: Record<string, PartnerProject>, meta: Meta, links: { next?: { href: string } } }>()
);

export const loadPartnerProjectsForLocationNextFailure = createAction(
  actionPrefix + ' Load PartnerProjects for location List Next Failed',
  props<{ locationUuid: string, error: Error }>()
);
